import _ from "lodash";
import {
  dehydrateSchedule,
  getChangedSchedules,
  getAddedSchedules,
  getRemovedSchedules,
} from "./schedules.selectors";
import { isFailure } from "@sportal/api";
import { getSubscriberId } from "../../../../store/info/info.selectors";
import { getProfilesChangedList } from "../../../../store/profiles/profiles.selectors";
import { getSchedules } from "../../../../store/root.selectors";

export const saveSchedules =
  () =>
  (dispatch, getState, { api }) => {
    const scheduleApi = api.ssm.schedules;
    const currentState = getState();
    const subscriberId = getSubscriberId(currentState);
    const profileList = getProfilesChangedList(currentState);
    const schedulesSlice = getSchedules(currentState);
    const added = getAddedSchedules(schedulesSlice);
    const removed = getRemovedSchedules(schedulesSlice);
    const changed = getChangedSchedules(schedulesSlice);

    return buildChain(preparePayload(removed), (schedule) =>
      scheduleApi.delete(
        subscriberId,
        schedule.profileName,
        schedule.schedule.name
      )
    )
      .then(() =>
        buildChain(preparePayload(added), (schedule) =>
          scheduleApi.create(
            subscriberId,
            schedule.profileName,
            schedule.schedule
          )
        )
      )
      .then(() =>
        buildChain(preparePayload(changed), (schedule) =>
          scheduleApi.update(
            subscriberId,
            schedule.profileName,
            schedule.schedule.name,
            schedule.schedule
          )
        )
      )
      .then(() => dispatch(saveSchedulesSuccess({ added, changed, removed })))
      .catch((error) => {
        dispatch(saveSchedulesError(error));

        return Promise.reject(error);
      });

    function buildChain(schedules, method) {
      return _.reduce(
        schedules,
        (acc, schedule) => {
          return acc.then(async () => {
            const result = await method(schedule);

            if (isFailure(result)) {
              return Promise.reject({
                error: result.error,
                scheduleName: schedule.schedule.name,
              });
            }
          });
        },
        Promise.resolve()
      );
    }

    function preparePayload(schedules) {
      return _.map(schedules, (schedule) => ({
        profileName: profileList[schedule.profile].name,
        schedule: dehydrateSchedule(schedule),
      }));
    }
  };

export const GET_SCHEDULES_SUCCESS = "[SCHEDULES] GET_SCHEDULES_SUCCESS";
export const ADD_SCHEDULE = "[SCHEDULES] ADD_SCHEDULE";
export const CHANGE_ENABLED = "[SCHEDULES] CHANGE_ENABLED";
export const CHANGE_CATEGORIES = "[SCHEDULES] CHANGE_CATEGORIES";
export const CHANGE_SCHEDULE = "[SCHEDULES] CHANGE_SCHEDULE";
export const CHANGE_SCHEDULES = "[SCHEDULES] CHANGE_SCHEDULES";
export const REMOVE_SCHEDULE = "[SCHEDULES] REMOVE_SCHEDULE";
export const SAVE_SCHEDULES_SUCCESS = "[SCHEDULES] SAVE_SCHEDULES_SUCCESS";
export const SAVE_SCHEDULES_ERROR = "[SCHEDULES] SAVE_SCHEDULES_ERROR";

export const getSchedulesSuccess = (profiles = []) => ({
  type: GET_SCHEDULES_SUCCESS,
  payload: profiles,
});
export const addSchedule = (schedule) => ({
  type: ADD_SCHEDULE,
  payload: schedule,
});

export const changeSchedules = (schedules) => ({
  type: CHANGE_SCHEDULES,
  payload: schedules,
});

export const changeEnabled = (type, profile, enabled) => ({
  type: CHANGE_ENABLED,
  payload: { type, profile, enabled },
});
export const changeCategories = (type, profile, categories) => ({
  type: CHANGE_CATEGORIES,
  payload: { type, profile, categories },
});
export const changeSchedule = (schedule) => ({
  type: CHANGE_SCHEDULE,
  payload: schedule,
});
export const removeSchedule = (scheduleId) => ({
  type: REMOVE_SCHEDULE,
  payload: scheduleId,
});
export const saveSchedulesSuccess = (schedules) => ({
  type: SAVE_SCHEDULES_SUCCESS,
  payload: schedules,
});
export const saveSchedulesError = (error) => ({
  type: SAVE_SCHEDULES_ERROR,
  payload: error,
});
